module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 139.4c269724.png";